export function getToken(): string | null {
    const match = new RegExp('backoffice.sid=([^;]+)').exec(document.cookie);

    if (match === null) {
        return null;
    }

    // let match = document.cookie.match(new RegExp(__SESSION_COOKIE_ID__ + '=([^;]+)'));
    return match[1] ?? null;
}

export function fractionalToDecimal(fractionalOdds: string): number {
    const [numerator = 0, denominator = 0] = fractionalOdds.split('/').map((value) => parseFloat(value));

    if (isNaN(numerator) || isNaN(denominator) || denominator === 0) {
        return 0;
    }

    return parseFloat((numerator / denominator + 1).toFixed(2));
}
